module.exports = "<footer class=\"main-footer\">\r\n  <div class=\"pull-right hidden-xs\">\r\n    <b>Version</b> 1.0\r\n  </div>\r\n  <strong>Copyright &copy; 2017 <a href=\"/\">Coin Alert</a>.</strong> All rights reserved.\r\n</footer>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_layouts/admin/admin-footer/admin-footer.component.html
// module id = ../../../../../src/app/_layouts/admin/admin-footer/admin-footer.component.html
// module chunks = main